import topic from '../topic';
export const settAPI = {
  getSetts: topic.settTopic + '/get_setts',
  getSettById: topic.settTopic + '/get_sett_by_id',
  addSett: topic.settTopic + '/add_sett',
  editSett: topic.settTopic + '/edit_sett',
  destroySettByIds: topic.settTopic + '/destroy_sett_by_ids'
};
